import { type JSX } from 'react';
import { FREETEXT_KEYS } from '~/const/freetext';
import { UNDERAGE_WARNING_MESSAGE } from '~/const/message';
import { WarningMessagePage } from '~/definitions/warningMessage';
import { getStore } from '~/mobx/AppStore';

export const renderWarning = (message: string, className = ''): JSX.Element => {
    return <div className={className}>{message}</div>;
};

export const renderAlreadyVotedWarning = (
    isUserAlreadyVoted: boolean,
    currentPage: WarningMessagePage
): JSX.Element | null => {
    if (isUserAlreadyVoted && currentPage === 'ballot') {
        const { freetextStore } = getStore();
        const message = freetextStore.getFreetextValueByKey(FREETEXT_KEYS.warning_already_voted);
        return renderWarning(message, 'already-voted-warning');
    }
    return null;
};

export const renderUnderageWarning = (isUserChild: boolean): JSX.Element | null => {
    if (isUserChild) {
        return renderWarning(UNDERAGE_WARNING_MESSAGE, 'underage-warning');
    }
    return null;
};
